let inArray = function(string, array) {
    let index = array.indexOf(string) + 1;
    if(index > 0) return true;
    else return false;
}

export default inArray;